// eslint-disable-next-line no-restricted-imports
import { Skeleton as SkeletonBase } from '@mui/material';

import { SkeletonProps } from './types';

/**
 * Skeleton component.
 */
export const Skeleton = (props: SkeletonProps) => <SkeletonBase {...props} />;
